import { render, staticRenderFns } from "./AdminRegistMasterForm.vue?vue&type=template&id=c6aae9d8&scoped=true"
import script from "./AdminRegistMasterForm.vue?vue&type=script&lang=js"
export * from "./AdminRegistMasterForm.vue?vue&type=script&lang=js"
import style0 from "./AdminRegistMasterForm.vue?vue&type=style&index=0&id=c6aae9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6aae9d8",
  null
  
)

export default component.exports